import { render, staticRenderFns } from "./ItemKitOrAccessoryList.vue?vue&type=template&id=62e72ab1&scoped=true&"
import script from "./ItemKitOrAccessoryList.vue?vue&type=script&lang=js&"
export * from "./ItemKitOrAccessoryList.vue?vue&type=script&lang=js&"
import style0 from "./ItemKitOrAccessoryList.vue?vue&type=style&index=0&id=62e72ab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e72ab1",
  null
  
)

export default component.exports